module.exports = __webpack_public_path__ + "media/PAG69-03.bad37ae2.mp3";